import { render, staticRenderFns } from "./LeaderboardTableRow.vue?vue&type=template&id=13e3640b&scoped=true"
import script from "./LeaderboardTableRow.vue?vue&type=script&lang=js"
export * from "./LeaderboardTableRow.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardTableRow.vue?vue&type=style&index=0&id=13e3640b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3640b",
  null
  
)

export default component.exports